module.exports = __webpack_public_path__ + "statics/img/pattern-background.3cefb89f.png";